import $api from "@/frontend/shared/api/axios";

export async function postRequestWebsiteUpdate({
  desiredWebsite,
  additionalNotes
}: {
  desiredWebsite: string;
  additionalNotes?: string;
}) {
  const response = await $api.post(`/founder-revisions/request-website-update`, { desiredWebsite, additionalNotes });
  return response;
}
